// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SynopsisWeatherProductAndSales {
  padding: 2rem;
}
.SynopsisWeatherProductAndSales .select_div {
  display: flex;
  justify-content: space-evenly;
}
.SynopsisWeatherProductAndSales .select_div .ant-select-selector {
  border-radius: 0.5rem;
  width: 12rem;
  box-shadow: #06bea7 0 -4px 15px -5px;
}
.SynopsisWeatherProductAndSales .select_div span {
  color: #06bea7;
}
.SynopsisWeatherProductAndSales .btn button {
  color: #06bea7;
  box-shadow: #06bea7 0 4px 15px -5px;
  margin-left: 15px;
}
.SynopsisWeatherProductAndSales .mainParent {
  padding: 1rem;
  display: flex;
  width: 100%;
  /* gap: 2rem; */
  height: 80vh;
}
.SynopsisWeatherProductAndSales .ant-spin-dot-item {
  background-color: black;
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/SynopsisWeatherProductAndSales.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,mCAAmC;EACnC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,aAAa;EACb,WAAW;EACX,eAAe;EACf,YAAY;AACd;AACA;EACE,uBAAuB;AACzB","sourcesContent":[".SynopsisWeatherProductAndSales {\n  padding: 2rem;\n}\n.SynopsisWeatherProductAndSales .select_div {\n  display: flex;\n  justify-content: space-evenly;\n}\n.SynopsisWeatherProductAndSales .select_div .ant-select-selector {\n  border-radius: 0.5rem;\n  width: 12rem;\n  box-shadow: #06bea7 0 -4px 15px -5px;\n}\n.SynopsisWeatherProductAndSales .select_div span {\n  color: #06bea7;\n}\n.SynopsisWeatherProductAndSales .btn button {\n  color: #06bea7;\n  box-shadow: #06bea7 0 4px 15px -5px;\n  margin-left: 15px;\n}\n.SynopsisWeatherProductAndSales .mainParent {\n  padding: 1rem;\n  display: flex;\n  width: 100%;\n  /* gap: 2rem; */\n  height: 80vh;\n}\n.SynopsisWeatherProductAndSales .ant-spin-dot-item {\n  background-color: black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
